export default __webpack_public_path__ + "static/media/sweets3.8103cc9f.jpg";